import React, { useState } from "react";
import { Container, Button } from "reactstrap";
import IndicadoresMonitoreo from "../../components/customer/potreros/monitoreoPotreros/IndicadoresMonitoreo";

import Header from "../../components/Header";
import HeaderTitle from "../../components/HeaderTitle";
import InformationModal from "../../components/InformationModal";
import { useEstablecimientos } from "../../providers/establecimientosProvider";
import InformacionPotreroModal from "../../components/customer/potreros/monitoreoPotreros/InformacionPotreroModal";
import {
  initialState,
  useInformacionPotreroModal,
} from "../../providers/informacionPotreroModalProvider";

import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAuth } from "../../providers/authProvider";
import { Redirect } from "react-router-dom";

const TYPE_SITUACION = "1"; // mode for InformacionPotreroModal

const ESTADO_ABIERTO = "1";

const MonitoreoPotreros = () => {
  const [authContext] = useAuth();
  const [establecimientosContext] = useEstablecimientos();
  const [informacionPotreroModalContext, setInformacionPotreroModalContext] =
    useInformacionPotreroModal();

  const [informationModal, setInformationModal] = useState({
    isOpen: false,
    title: "",
    body: "",
  });

  const onInformacionModal = () => {
    if (!establecimientosContext.selected) {
      return setInformationModal({
        isOpen: true,
        title: "Agregar Información de Potreros",
        body: `
        <p>No hay ningún establecimiento seleccionado.</p>
        <span>Selecciona un establecimiento desde la barra lateral para administrarlo.</span>
      `,
      });
    }
    const selected = establecimientosContext.allEstablecimientos.find(
      (e) => e.id === establecimientosContext.selected
    );
    if (selected.estado !== ESTADO_ABIERTO) {
      return setInformationModal({
        isOpen: true,
        title: "Importar Potreros",
        body: `
        <p>El establecimiento esta en estado cerrado, por lo que no se puede agregar información.</p>
        <span>Edita el estado del establecimiento desde la sección de establecimientos para realizar cambios.</span>
      `,
      });
    }
    setInformacionPotreroModalContext({
      ...initialState,
      isOpen: true,
      mode: TYPE_SITUACION,
    });
  };

  const selectedEstablecimiento = () =>
    (establecimientosContext.allEstablecimientos || []).find(
      (e) => e.id === establecimientosContext.selected
    )?.nombre || "";

  return authContext.currentUser?.enabledMonitoreo ? (
    <Container fluid className="d-flex flex-column flex-grow-1 mx-0 w-100">
      <Header className="mb-3">
        <HeaderTitle className="d-flex flex-wrap justify-content-between">
          <div className="d-flex flex-column col-12 px-0 col-lg-6 align-items-start">
            <span className="col-12 px-0 text-dark">
              Monitoreo de Potreros {selectedEstablecimiento()}
            </span>
            <small className="col-12 px-0 text-muted font-size-75">
              Estadísticas
            </small>
          </div>
          <div className="d-flex justify-content-end mt-2 mt-lg-0 col-12 col-lg-6 px-0 align-items-center">
            <Button
              size="sm"
              color="warning"
              className="rounded ml-2 btn-success font-weight-bold text-white text-uppercase py-1"
              onClick={onInformacionModal}
            >
              <FontAwesomeIcon icon={faPlus} className="mr-2" />
              Ingresar Monitoreo
            </Button>
          </div>
        </HeaderTitle>
      </Header>
      <IndicadoresMonitoreo />
      {informationModal.isOpen ? (
        <InformationModal
          title={informationModal.title}
          body={informationModal.body}
          rawBody={informationModal.rawBody}
          onClose={() =>
            informationModal.onClose
              ? informationModal.onClose()
              : setInformationModal({ isOpen: false, title: "", body: "" })
          }
        />
      ) : null}
      {informacionPotreroModalContext.isOpen ? (
        <InformacionPotreroModal
          onClose={() => setInformacionPotreroModalContext(initialState)}
        />
      ) : null}
    </Container>
  ) : (
    <Redirect to={`/error/404`} />
  );
};

export default MonitoreoPotreros;
